export function isStandardMolecularFeature(feature: string) {
  return STANDARD_MOLECULEAR_FEATURES.includes(feature);
}

export function isExtendedMolecularFeature(feature: string) {
  return EXTENDED_MOLECULEAR_FEATURES.includes(feature);
}

export const STANDARD_MOLECULEAR_FEATURES = [
  "AcidGroupCount",
  "AtomCount",
  "AtomicPolarizability",
  "BondCount",
  "HBondAcceptorCount",
  "HBondDonorCount",
  "MassAutocorr",
  "PolarizabilityAutocorr",
];

export const EXTENDED_MOLECULEAR_FEATURES = [
  "ALOGP",
  "AromaticAtomCount",
  "AromaticBondCount",
  "BasicGroupCount",
  "BPol",
  "CarbonTypes",
  "EccentricConnectivityIndex",
  "FMF",
  "FragmentComplexity",
  "HybridizationRatioDescriptor",
  "KappaShapeIndices",
  "KierHallSmarts",
  "LargestChain",
  "LargestPiSystem",
  "MannholdLogP",
  "MDE",
  "PetitjeanNumber",
  "RotatableBondsCount",
  "RuleOfFive",
  "TopologicalSurfaceArea",
  "VertexAdjacencyMagnitude",
  "Weight",
  "WienerNumbers",
  "XLogP",
  "ZagrebIndex",
];
